/**
 * Routing/loading-gate decisions for the top-level `App` component.
 *
 * Extracted as pure functions so they are testable without mounting the full app
 * (the vitest env here has no jsdom).
 *
 * Auth routes do not depend on an interactive user profile, so they must not be
 * blocked by the global loading gate (unmounting SignInPage on profile refresh).
 */

/** Auth routes rendered without the app shell (no authenticated profile required). */
export function isAuthPath(pathname: string): boolean {
  return (
    pathname === '/signin' ||
    pathname === '/forgot-password' ||
    pathname === '/auth/set-password' ||
    pathname === '/auth/setpassword' ||
    pathname.startsWith('/auth/callback') ||
    pathname.startsWith('/set-password/')
  );
}

/**
 * Whether the global `<Loading/>` gate should block rendering of the current route.
 *
 * Only non-auth routes are blocked while Medplum is loading. Auth routes never
 * block — they do not depend on the authenticated profile.
 */
export function shouldBlockRenderWhileLoading(isLoading: boolean, pathname: string): boolean {
  return isLoading && !isAuthPath(pathname);
}
